export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf03-de.f640722d.png";